// extracted by mini-css-extract-plugin
export default {"root":"CheckboxField_root__YqJrp","inner":"CheckboxField_inner__d3fj0","styledCheckbox":"CheckboxField_styledCheckbox__lPvRu","content":"CheckboxField_content__JFDuh"};